import React from 'react';
import SpanSpinner from '../../../Shared/SpanSpinner/SpanSpinner';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import './Login.scss';
import { createAccount } from '../../../../Redux/Actions/AccountCreateActions';
import { validationService } from '../../../../services/validation.service';
import { Alert } from 'reactstrap';
import { LoginMenu } from '../../Authentication/LoginMenu/LoginMenu';

class Login extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            password: '',
            passwordConfirm: '',
            emailError: '',
            passwordError: '',
            confirmPasswordError: '',
            visible: true
        };

    }

    render() {
        return (
            <div>
                <div className="login-page">
                    {this.props.error? (
                        <Alert
                            color="red"
                            isOpen={this.state.visible}
                            style={{ position: 'fixed', width: '100%', color: 'white', backgroundColor: "red" }}
                        >
                            {this.props.error}
                        </Alert>
                    ) : null}
                    <div className="create-account-content">
                        <div className='container-fluid'>
                            <h1 className="text-left">Please Log in to Continue</h1>
                            <p>Please log in using the email address and password you provided when you created your account.</p>
                            <LoginMenu toggle={() => true}/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { submitting, error } = state.createAccount;
    return {
        submitting,
        error
    };
}

export default withRouter(connect(mapStateToProps)(Login));

